import { render, staticRenderFns } from "./atualizar-tabelapreco.vue?vue&type=template&id=6020a2ab"
import script from "./atualizar-tabelapreco.vue?vue&type=script&lang=js"
export * from "./atualizar-tabelapreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports